import { Box, HStack, SpaceProps } from '@chakra-ui/react'
import { themeColors } from 'theme'

interface CustomComponentProps {
  dotsLength: number
  activeDotIndex: number
  paddingBottom?: SpaceProps['pb']
}

const CustomPagination: React.FC<CustomComponentProps> = ({ activeDotIndex, dotsLength, paddingBottom }) => {
  const { dots: { bgActive, bgInActive } } = themeColors
  const activeIndex = activeDotIndex > dotsLength - 1 ? 0 : activeDotIndex

  return (
    <HStack
      width={'full'}
      spacing={4}
      justifyContent={'center'}
      paddingBottom={paddingBottom}>
      {[...Array(dotsLength).keys()].map((item, index) => {
        return (
          <Box
            key={`${item}`}
            height={'12px'}
            width={'12px'}
            opacity={index === activeIndex ? 1 : 0.7}
            borderRadius={'full'}
            bgColor={index === activeIndex ? bgActive : bgInActive}
          ></Box>
        )
      })}
    </HStack>
  )
}

export default CustomPagination
